const MIN_COMPANY_VALUE = 50000000;
const MAX_COMPANY_VALUE = 99999999;

export const isCompanyRut = (value: string) => {
  if (!value) return false;
  const formmatedValue = value.replace(/\./g, "");
  const cleanValue: number = Number.parseInt(formmatedValue.split("-")[0], 10);
  return MIN_COMPANY_VALUE <= cleanValue && cleanValue <= MAX_COMPANY_VALUE;
};
